import React, { useEffect, useState } from "react";
import { createCustomerSession } from "../api/stripe";
import {Config} from "../utils";

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'stripe-pricing-table': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}

const StripePricingTable = () => {
  const [customerSecret, setCustomerSecret] = useState<string | null>(null);

  const accountId = parseFloat(localStorage.getItem("accountId") || "0");
  const customerId = localStorage.getItem("customerId") || ""
  const plansPricingTableId = Config.pricingTablePlansId || null;
  // const user = localStorage.getItem("quipa-store");
  // const email = user ? JSON.parse(user).user.email : "";

  useEffect(() => {

    const fetchCustomerSecret = async () => {
      if (customerId) {
        try {
          const secret = await createCustomerSession(customerId);
          console.log(secret);
          
          setCustomerSecret(secret.client_secret);
        } catch (error) {
          console.error("Error creating customer session:", error);
        }
      }
    };
  
    fetchCustomerSecret();

    const scriptId = "stripe-pricing-table-js";

    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://js.stripe.com/v3/pricing-table.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <stripe-pricing-table
      pricing-table-id={plansPricingTableId || null}
      publishable-key={Config.stripePk}
      client-reference-id={accountId}
      customer-session-client-secret={customerSecret}
    ></stripe-pricing-table>
  );
};

export default StripePricingTable;
